import React from "react";
import "./css/divisorcenter.css";
import PropTypes from "prop-types";

const Divisorcenter = ({ title, description }) => {
  return (
    <div className="d-flex flex-column align-items-center my-5 text-center">
      <div className="d-flex align-items-center w-100 justify-content-center">
        <div className="flex-grow-1 border-top line ms-5"></div>
        <h5 className="mx-4 text-gris-bold-description-hv">{title}</h5>
        <div className="flex-grow-1 border-top line me-5"></div>
      </div>
      <div className="color-text-body-description-hv">{description}</div>
    </div>
  );
};

Divisorcenter.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default Divisorcenter;
